module.exports = __webpack_public_path__ + "img/ep-boule-de-noel.012cd4b1.png";